<!-- src/app/layout/main-layout/layout.component.html -->
<div class="layout-root">

    <!-- Sidebar (fijo, no scroll) -->
    <app-sidebar #sidebar></app-sidebar>

    <!-- Área principal: scroll solo aquí -->
    <div class="layout-main" [class.sidebar-collapsed]="layout.sidebarCollapsed()">

        <!-- Topbar (sticky) -->
        <app-topbar (menuToggle)="sidebar.toggleMobile()"></app-topbar>

        <!-- Contenido scrolleable -->
        <main class="layout-content">
            <router-outlet></router-outlet>
        </main>

        <!-- Footer (sticky bottom) -->
        <app-footer></app-footer>

    </div>

    <!-- Toast global -->
    <p-toast position="top-right" key="toast" [life]="4000"></p-toast>

    <!-- Gate diario de herramientas (TECNICO / SUPERVISOR) -->
    <app-work-session-gate />

</div>